import { render, staticRenderFns } from "./DataAccessForm.vue?vue&type=template&id=6763ce7c&"
import script from "./DataAccessForm.vue?vue&type=script&lang=js&"
export * from "./DataAccessForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6763ce7c')) {
      api.createRecord('6763ce7c', component.options)
    } else {
      api.reload('6763ce7c', component.options)
    }
    module.hot.accept("./DataAccessForm.vue?vue&type=template&id=6763ce7c&", function () {
      api.rerender('6763ce7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DataAccessForm.vue"
export default component.exports